import { Trans } from '@lingui/react'

import Price from 'views/components/atoms/Price'
import CheckoutButton from 'views/components/organisms/CartSumBox/CheckoutButton'

import './CartStickyCta.scss'

type CartStickyCtaProps = {
  button?: {
    id: string
    label: string
    href: string
  }
  submitButtonAction: () => void
  disableSubmitButton: boolean
  totalAmount: number
  currency: string
}

const CartStickyCta = ({
  button,
  submitButtonAction,
  disableSubmitButton,
  totalAmount,
  currency,
}: CartStickyCtaProps) => {
  return (
    <div
      className="o-stickyCta u-border-light--top u-hidden"
      data-clientside-hook="sticky-cta"
    >
      <div className="u-position--relative">
        <div className="o-stickyCta-content l-flex l-flex--center l-col--7-of-12@medium l-col--4-of-12@large u-margin--auto u-padding--bottom l-flex--end u-padding--sides@small-tiny">
          <div className="a-p8 l-flex l-flex__column">
            <span className="u-color--grey">
              <Trans id="general.label.totalSum" />
            </span>
            <Price
              amount={totalAmount}
              currency={currency}
              dataQa="cart-sumBox-totalSum"
              className
            />
          </div>
          {button && (
            <CheckoutButton
              button={button}
              submitButtonAction={submitButtonAction}
              disableSubmitButton={disableSubmitButton}
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default CartStickyCta
